import React, { useState, useEffect } from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import '../../pages/Admin/Admin.styles.css';

const AdminLayout = () => {
    const location = useLocation();
    const [isDarkMode, setIsDarkMode] = useState(false);
    const [recceExpanded, setRecceExpanded] = useState(false);

    useEffect(() => {
        // Check for saved theme preference or default to light mode
        const savedTheme = localStorage.getItem('admin-theme') || 'light';
        setIsDarkMode(savedTheme === 'dark');
        document.documentElement.className = savedTheme;
    }, []);

    const toggleTheme = () => {
        const newTheme = isDarkMode ? 'light' : 'dark';
        setIsDarkMode(!isDarkMode);
        document.documentElement.className = newTheme;
        localStorage.setItem('admin-theme', newTheme);
    };

    const isActive = (path) => location.pathname === path ? 'active' : '';

    return (
        <div className="admin-layout">
            {/* Sidebar */}
            <aside className="admin-sidebar">
                {/* Logo */}
                <div className="admin-sidebar-logo">
                    <div className="admin-sidebar-logo-icon">
                        <span className="material-icons-outlined">location_on</span>
                    </div>
                    <span className="admin-sidebar-logo-text">
                        Monit GPS
                        <span className="brand-suffix">Admin</span>
                    </span>
                </div>

                {/* Navigation */}
                <nav className="admin-nav">
                    <ul className="admin-nav-list">
                        <li>
                            <Link to="/admin" className={`admin-nav-item ${isActive('/admin')}`}>
                                <span className="material-icons-outlined">dashboard</span>
                                <span>Dashboard</span>
                            </Link>
                        </li>
                        <li>
                            <Link to="/admin/update-device" className={`admin-nav-item ${isActive('/admin/update-device')}`}>
                                <span className="material-icons-outlined">edit</span>
                                <span>Update Device Name</span>
                            </Link>
                        </li>
                        <li>
                            <Link to="/admin/import" className={`admin-nav-item ${isActive('/admin/import')}`}>
                                <span className="material-icons-outlined">upload_file</span>
                                <span>Stage Import</span>
                            </Link>
                        </li>
                        <li>
                            <Link to="/admin/messages" className={`admin-nav-item ${isActive('/admin/messages')}`}>
                                <span className="material-icons-outlined">sms</span>
                                <span>Messages / SMS</span>
                            </Link>
                        </li>
                        {/* RECCE Data Menu */}
                        <li>
                            <div
                                className={`admin-nav-item ${location.pathname.includes('/admin/recce') ? 'active' : ''}`}
                                onClick={() => setRecceExpanded(!recceExpanded)}
                                style={{
                                    cursor: 'pointer',
                                    justifyContent: 'space-between',
                                    paddingRight: '1rem'  // Add padding for the arrow icon
                                }}
                            >
                                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                                    <span className="material-icons-outlined">folder_open</span>
                                    <span>RECCE Data</span>
                                </div>
                                <span className="material-icons-outlined" style={{ fontSize: '1.2rem' }}>
                                    {recceExpanded ? 'expand_less' : 'expand_more'}
                                </span>
                            </div>

                            {/* Submenu */}
                            {(recceExpanded || location.pathname.includes('/admin/recce')) && (
                                <ul className="admin-nav-sublist" style={{
                                    listStyle: 'none',
                                    paddingLeft: '0',
                                    marginTop: '0.25rem',
                                    background: 'var(--bg-secondary)',
                                    borderRadius: '0 0 8px 8px',
                                    borderLeft: '2px solid var(--accent-primary)',
                                    marginLeft: '1.5rem',
                                    marginBottom: '0.5rem'
                                }}>
                                    <li>
                                        <Link
                                            to="/admin/recce/report"
                                            className={`admin-nav-item ${isActive('/admin/recce/report')}`}
                                            style={{
                                                paddingLeft: '1rem',
                                                fontSize: '0.9rem',
                                                height: '40px',
                                                color: isActive('/admin/recce/report') ? 'var(--accent-primary)' : 'var(--text-secondary)'
                                            }}
                                        >
                                            <span className="material-icons-outlined" style={{ fontSize: '1.2rem' }}>description</span>
                                            <span>RECCE Report</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            to="/admin/recce/penalty"
                                            className={`admin-nav-item ${isActive('/admin/recce/penalty')}`}
                                            style={{
                                                paddingLeft: '1rem',
                                                fontSize: '0.9rem',
                                                height: '40px',
                                                color: isActive('/admin/recce/penalty') ? 'var(--accent-primary)' : 'var(--text-secondary)'
                                            }}
                                        >
                                            <span className="material-icons-outlined" style={{ fontSize: '1.2rem' }}>gavel</span>
                                            <span>RECCE Penalty</span>
                                        </Link>
                                    </li>
                                </ul>
                            )}
                        </li>
                        <li>
                            <Link to="/admin/cars" className={`admin-nav-item ${isActive('/admin/cars')}`}>
                                <span className="material-icons-outlined">directions_car</span>
                                <span>Cars Management</span>
                            </Link>
                        </li>
                        <li>
                            <Link to="/admin/history" className={`admin-nav-item ${isActive('/admin/history')}`}>
                                <span className="material-icons-outlined">history</span>
                                <span>Command History</span>
                            </Link>
                        </li>
                        <li>
                            <Link to="/admin/compare" className={`admin-nav-item ${isActive('/admin/compare')}`}>
                                <span className="material-icons-outlined">compare_arrows</span>
                                <span>Compare Cars</span>
                            </Link>
                        </li>
                        <li>
                            <Link to="/admin/geofences" className={`admin-nav-item ${isActive('/admin/geofences')}`}>
                                <span className="material-icons-outlined">map</span>
                                <span>Admin Geofences</span>
                            </Link>
                        </li>
                        <li>
                            <Link to="/admin/splits" className={`admin-nav-item ${isActive('/admin/splits')}`}>
                                <span className="material-icons-outlined">list</span>
                                <span>Split List</span>
                            </Link>
                        </li>
                        <li>
                            <Link to="/admin/safety-points" className={`admin-nav-item ${isActive('/admin/safety-points')}`}>
                                <span className="material-icons-outlined">medical_services</span>
                                <span>Safety Points</span>
                            </Link>
                        </li>
                    </ul>
                </nav>

                {/* Footer */}
                <div className="admin-sidebar-footer">
                    <Link to="/" className="admin-sidebar-settings">
                        <span className="material-icons-outlined">arrow_back</span>
                        <span>Back to Monitoring</span>
                    </Link>
                    <div className="admin-sidebar-user">
                        <img
                            src="https://ui-avatars.com/api/?name=Admin+User&background=2563eb&color=fff"
                            alt="Admin user avatar"
                            className="admin-sidebar-user-avatar"
                        />
                        <div className="admin-sidebar-user-info">
                            <p className="admin-sidebar-user-name">Admin User</p>
                            <p className="admin-sidebar-user-role">System Admin</p>
                        </div>
                    </div>
                </div>
            </aside>

            {/* Main Content */}
            <main className="admin-content">
                {/* Header */}
                <header className="admin-header">
                    <h1 className="admin-header-title">
                        {location.pathname === '/admin' && 'Dashboard'}
                        {location.pathname === '/admin/update-device' && 'Update Device Name'}
                        {location.pathname === '/admin/messages' && 'Messages / SMS'}
                        {location.pathname === '/admin/import' && 'Stage Import'}
                        {location.pathname.includes('/admin/recce/report') && 'RECCE Report'}
                        {location.pathname.includes('/admin/recce/penalty') && 'RECCE Penalty'}
                        {location.pathname === '/admin/cars' && 'Cars Management'}
                        {location.pathname === '/admin/history' && 'Command History'}
                        {location.pathname === '/admin/compare' && 'Compare Cars'}
                        {location.pathname === '/admin/geofences' && 'Admin Geofences'}
                        {location.pathname === '/admin/splits' && 'Split List'}
                        {location.pathname === '/admin/safety-points' && 'Safety Points'}
                    </h1>
                    <div className="admin-header-actions">
                        <div className="admin-status-badge">
                            <span className="status-dot"></span>
                            System Active
                        </div>
                        <div className="admin-header-divider"></div>
                        <button className="admin-theme-toggle" onClick={toggleTheme}>
                            {isDarkMode ? (
                                <span className="material-icons-outlined" style={{ color: '#fbbf24' }}>light_mode</span>
                            ) : (
                                <span className="material-icons-outlined">dark_mode</span>
                            )}
                        </button>
                    </div>
                </header>

                {/* Page Content */}
                <div className="admin-main">
                    <Outlet />
                </div>

                {/* Footer */}
                <footer className="admin-footer">
                    <div className="admin-footer-content">
                        <span className="admin-footer-item">
                            <span className="admin-footer-item-label">© 2024 Monit GPS Systems</span>
                        </span>
                    </div>
                </footer>
            </main>
        </div >
    );
};

export default AdminLayout;


